import { Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { PublicSelectEnumComponent } from '@componentes/public-select/public-select-enum.component';
import {
	getLabelVariavel,
	ValuesVariaveis,
} from '@home/submodulos/dados-meteorologicos/submodulos/monitoramento/pages/variaveis/interfaces/variaveis';

@Component({
	selector: 'seira-public-select-variavel-estacoes-automaticas',
	templateUrl: './public-select.component.html',
	styleUrls: ['./public-select.component.scss'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			multi: true,
			useExisting: forwardRef(
				() => PublicSelectVariavelEstacoesAutomaticasComponent
			),
		},
	],
})
export class PublicSelectVariavelEstacoesAutomaticasComponent extends PublicSelectEnumComponent {
	override label = 'Variável';
	override notFoundText = 'Nenhuma variável foi encontrada';
	override placeholder = 'Informe a variável desejada';

	constructor() {
		super(ValuesVariaveis, getLabelVariavel);
	}
}
